import { Injectable } from "@angular/core";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { ToasterComponent } from "./toaster.component";

@Injectable({
  providedIn: "root",
})
export class ToasterService {
  constructor(public snackBar: MatSnackBar) {}

  readonly defaultConfig: MatSnackBarConfig = {
    duration: 3000,
    horizontalPosition: "center",
    verticalPosition: "top",
    panelClass: "cimsup-snackbar",
  };

  public toast(
    level: "error" | "success" | "info",
    message: string,
    config: MatSnackBarConfig = {},
    messageMap: any = {},
    goTo: string = ""
  ) {
    return this.snackBar.openFromComponent(
      ToasterComponent,
      Object.assign(
        this.defaultConfig,
        {
          data: { level, message, messageMap, goTo },
          panelClass: [this.defaultConfig.panelClass, level],
        },
        config
      )
    );
  }
}
